import { render, staticRenderFns } from "./CurrencyDisplay.vue?vue&type=template&id=5290858f"
import script from "./CurrencyDisplay.vue?vue&type=script&lang=js"
export * from "./CurrencyDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports